import { l } from '@manychat/manyui'

import { INSTAGRAM_REACTION_TYPE } from 'apps/chat/components/ChatMessage/constants'
import { ChatMessageBlock, ChatMessageBlockInterface } from 'apps/chat/types/chatMessageBlockTypes'
import { ChatMessageBlockType } from 'apps/chat/types/chatMessagesBlockList'
import { ChatMessageInterface } from 'apps/chat/types/chatMessageTypes'
import {
  GetMessages,
  NOTIFY_BUTTON_LABELS,
  ReasonTypes,
} from 'common/oneTimeNotify/constants/notifyReasonConstants'

export function getBlockText(block: ChatMessageBlockInterface): string | undefined {
  if (
    'content' in block &&
    'text' in block.content &&
    block.content.text &&
    typeof block.content.text === 'string'
  ) {
    return block.content.text
  }

  if ('text' in block && block.text && typeof block.text === 'string') {
    return block.text
  }

  return undefined
}

export function getOtnButtonLabel(block: ChatMessageBlockInterface) {
  let label = l.getString(GetMessages)

  if ('content' in block && 'one_time_notify_reason_type' in block.content) {
    const reasonType = block?.content?.one_time_notify_reason_type as ReasonTypes
    label = l.getString(NOTIFY_BUTTON_LABELS[reasonType]) ?? label
  }

  return label
}

export const getBlockMessageEmojis = ({
  block,
  message,
}: {
  block: ChatMessageBlockInterface
  message: ChatMessageInterface
}) => {
  if ('emojis' in block) {
    return block.emojis
  }

  if ('emojis' in message) {
    return message.emojis
  }

  return null
}

export function isSmsBlock(block: ChatMessageBlockInterface) {
  return block.type === ChatMessageBlockType.SMS
}

export const combineFBGuestLinkBlocks = (blocks: ChatMessageBlockInterface[] = []) => {
  const links = blocks.filter((block) => block.type === ChatMessageBlockType.GUEST_LINK)

  if (links.length) {
    const blocksWithoutFbGuestLink = blocks.filter(
      (block) => block.type !== ChatMessageBlockType.GUEST_LINK,
    )
    const facebookLinkToGuestBlock: ChatMessageBlock.GuestLink = {
      type: ChatMessageBlockType.GUEST_LINK,
      links,
    }

    return [...blocksWithoutFbGuestLink, facebookLinkToGuestBlock]
  }

  return blocks
}

export const getIsBlockWithButtons = (block: ChatMessageBlockInterface) => {
  const hasRegularButtons =
    'keyboard' in block && Array.isArray(block.keyboard) && block.keyboard.length
  const isQuestionLocation =
    block.type === ChatMessageBlockType.QUESTION && block.answer_type === 'location'

  return Boolean(hasRegularButtons || isQuestionLocation)
}
